module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confirmed"
    }
  }, [(_vm.searching) ? _c('div', [_c('strong', [_vm._v("Loading. Please wait...")])]) : _vm._e(), _vm._v(" "), (!_vm.searching) ? _c('div', [_c('h1', [_vm._v("Confirmed Faces")])]) : _vm._e(), _vm._v(" "), (_vm.faces_confirmed && _vm.faces_confirmed.length && !_vm.searching) ? _c('div', {
    staticClass: "confirmed-list"
  }, [_vm._l((_vm.facesConfirmedFiltered), function(confirmed) {
    return _c('div', {
      key: confirmed.runtime_face_uuid,
      staticClass: "confirmed-list-entry"
    }, [_c('div', {
      staticClass: "left-info-area"
    }, [_c('router-link', {
      staticClass: "face-name",
      attrs: {
        "to": '/faces/' + confirmed.person_name
      }
    }, [_vm._v(_vm._s(confirmed.person_name))]), _c('br'), _vm._v("\n        " + _vm._s(confirmed.camera_description)), _c('br'), _vm._v("\n        " + _vm._s(_vm.getTimeString(confirmed.captured_at))), _c('br')], 1), _vm._v(" "), _c('div', {
      staticClass: "frontend-image-area"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (confirmed.frontend_image_uri),
        expression: "confirmed.frontend_image_uri"
      }],
      staticClass: "frontend-image",
      attrs: {
        "height": "160"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "runtime-image-area"
    }, [_c('img', {
      staticClass: "runtime-image",
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + confirmed.runtime_face_uuid + '?shape=1&clahe=1',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "right-info-area"
      }
    }, [_vm._v("\n        Tagged by " + _vm._s(confirmed.tagged_by)), _c('br'), _vm._v("\n        " + _vm._s(confirmed.confirmed_at && _vm.getTimeDiff(confirmed.confirmed_at)) + "\n      ")]), _vm._v(" "), _c('button', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.wrongShape(confirmed.frontend_face_uuid, confirmed.runtime_face_uuid)
        }
      }
    }, [_vm._v("Wrong Shape & Remove")]), _vm._v(" "), _c('button', {
      staticClass: "ui negative button",
      on: {
        "click": function($event) {
          _vm.removeConfirm(confirmed.frontend_face_uuid, confirmed.runtime_face_uuid)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), (_vm.more_available) ? _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.getMoreResults
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.searching && _vm.faces_confirmed && !_vm.faces_confirmed.length) ? _c('div', [_vm._v("\n    No results.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f27d0502","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirmed.vue
// module id = 308
// module chunks = 1